var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNaNamibia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_21430)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0H0V45H60V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4746 0.01875L62.3996 32.4187L11.9527 0L62.4746 0.01875Z",
    fill: "#3662A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.4752 44.9627L-2.34395 11.2783L48.5342 44.9814L-2.46582 44.9627H-2.4752Z",
    fill: "#38A100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4375 34.8564L62.4 45.0002L51.3844 44.9908L-2.38126 8.94395L-2.31563 0.12207L8.55937 0.0283203L62.4375 34.8471V34.8564Z",
    fill: "#C70000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4123 16.125L41.4561 14.8875L42.6373 16.9594L43.7811 14.8781L45.8436 16.0875L45.7873 13.7062L48.1686 13.725L46.9311 11.6812L49.0029 10.5094L46.9217 9.35625L48.1217 7.29375L45.7404 7.35L45.7498 4.95938L43.7154 6.19687L42.5342 4.125L41.3904 6.20625L39.3279 4.99687L39.3842 7.37812L37.0029 7.35938L38.2404 9.40313L36.1686 10.575L38.2498 11.7281L37.0498 13.7906L39.4311 13.7344L39.4123 16.125Z",
    fill: "#FFE700"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2117 10.5373C38.2117 12.9373 40.1711 14.8779 42.5805 14.8779C44.9898 14.8779 46.9492 12.9373 46.9492 10.5373C46.9492 8.13731 44.9992 6.20605 42.5805 6.20605C40.1617 6.20605 38.2117 8.14668 38.2117 10.5373Z",
    fill: "#3662A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1592 10.5376C39.1592 11.4451 39.5197 12.3155 40.1614 12.9572C40.8032 13.599 41.6735 13.9595 42.5811 13.9595C43.4886 13.9595 44.359 13.599 45.0007 12.9572C45.6424 12.3155 46.0029 11.4451 46.0029 10.5376C46.0029 9.63006 45.6424 8.75969 45.0007 8.11797C44.359 7.47624 43.4886 7.11572 42.5811 7.11572C41.6735 7.11572 40.8032 7.47624 40.1614 8.11797C39.5197 8.75969 39.1592 9.63006 39.1592 10.5376Z",
    fill: "#FFE700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_21430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaNamibia);
export default __webpack_public_path__ + "static/media/na Namibia.06d888cbf51745d5bd975c39597e1d95.svg";
export { ForwardRef as ReactComponent };